<!-- Adapted from Koel ui/ThumbnailStack.vue, 40183ac (MIT). -->
<template><article class="thumbnail-stack" :class="displayedThumbnails.length < 4 ? 'single' : 'tiles'"><img v-for="(thumbnail, index) in displayedThumbnails" :key="thumbnail + index" :src="thumbnail" alt="" loading="lazy" @error="fallback" /></article></template>
<script>
import { runtime } from '../../bridge';
export default {
  name: 'KoelThumbnailStack', props: { thumbnails: { type: Array, default: () => [] } },
  computed: { displayedThumbnails() { const images = this.thumbnails.filter(Boolean); return (images.length ? images.slice(0, images.length < 4 ? 1 : 4) : [runtime.cover()]); } },
  methods: { fallback(event) { if (event.currentTarget.dataset.fallback) return; event.currentTarget.dataset.fallback = '1'; event.currentTarget.src = runtime.cover(); } },
};
</script>
<style scoped>
.thumbnail-stack { display: grid; width: 100%; height: 100%; overflow: hidden; background: var(--salt-surface, #ddd); }
.thumbnail-stack.tiles { grid-template-columns: repeat(2, minmax(0,1fr)); grid-template-rows: repeat(2,minmax(0,1fr)); }
.thumbnail-stack img { display: block; width: 100%; height: 100%; object-fit: cover; min-width: 0; min-height: 0; }
</style>
